import { Model } from '@vuex-orm/core'
import Room from '@models/building/Room'
import Roomtype from '@models/helpers/Roomtype'
import Roomltm from '@models/helpers/Roomltm'
import pageValidation from '@services/validations/pageValidation'

export default class Installation extends Model{
  static entity = 'installations'
  static fields () {
    return {
      id: this.uid(),
      unitId: this.attr(null),

      au: this.number(1),
      fo: this.number(1),
      ewt: this.number(0),
      storey: this.number(1),
      pipeDiameter: this.number(null).nullable(),
    }
  }

  getAnschlussType() {
    if (this.ewt == 1) {
      if (this.au == 0 && this.fo == 1) {
        return 5;
      }
      if (this.au == 0 && this.fo == 2) {
        return 6;
      } 
    }
    if (this.ewt == 2 ) {
      if (this.au == 1 && this.fo == 1) {
        return 7;
      }
      if (this.au == 1 && this.fo == 2) {
        return 8;
      } 
    }
  
    if (this.au == 1 && this.fo == 1) {
      return 1;
    } 
    if(this.au == 1 && this.fo == 2) {
      return 2;
    } 
    if(this.au == 2 && this.fo == 1) {
      return 3;
    }
    if (this.au == 2 && this.fo == 2) {
      return 4;
    }
    return 0; 
  }
} 